import { produce } from 'immer';
import { reducer as originalReducer, defaultStateRaw } from '@core/js/hooks/user/store/reducer';

import * as Types from './types';
import { actionTypes } from './constants';
import { storageService } from '@core/js/services/storage.service';

import { TUserAction as OriginalTUserAction } from '@core/js/hooks/user/store/types';

export { defaultStateRaw } from '@core/js/hooks/user/store/reducer';

type TUserAction = OriginalTUserAction | Types.ISetCUBalanceAction;

const userStorageData: Types.IUserState = storageService.session.getItem('user');
export const defaultState: Types.IUserState = { ...defaultStateRaw, ...userStorageData };

export const reducer = produce((draftState, action: TUserAction): Types.IUserState | void => {
    if (action.type === actionTypes.SET_CU_BALANCE) {
        draftState.cuBalance = action.payload;
        return;
    }
    return originalReducer(draftState, action as OriginalTUserAction);
}, defaultState);
